import React from 'react';
import PropTypes from 'prop-types';
import { LuFileText, LuFileSpreadsheet, LuFileImage, LuFile } from 'react-icons/lu';

const fileIcon = (name = '', type = '') => {
  const ext = String(name).split('.').pop().toLowerCase();
  if (type.includes('pdf')   || ext === 'pdf')                        return { Icon: LuFileText,        color: '#dc2626' };
  if (type.includes('excel') || ['xls', 'xlsx', 'csv'].includes(ext)) return { Icon: LuFileSpreadsheet, color: '#16a34a' };
  if (type.includes('word')  || ['doc', 'docx'].includes(ext))        return { Icon: LuFileText,        color: '#2563eb' };
  if (type.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext))
                                                                      return { Icon: LuFileImage,       color: '#d97706' };
  return { Icon: LuFile, color: '#64748b' };
};

const fmtBytes = (n) => {
  if (!n) return '';
  if (n < 1024)        return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

/** Attachment chips under an activity/task row. */
const ActivityAttachments = ({ attachments }) => {
  if (!attachments?.length) return null;

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-1.5 tw-mt-2">
      {attachments.map((a) => {
        const { Icon, color } = fileIcon(a.file_name, a.content_type || '');
        return (
          <a
            key={a.id}
            href={a.url}
            target="_blank"
            rel="noreferrer"
            title={a.file_name}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white hover:tw-border-primary-300 hover:tw-bg-primary-50 tw-transition-colors tw-no-underline tw-max-w-[200px]"
          >
            <Icon size={12} style={{ color, flexShrink: 0 }} />
            <span className="tw-text-[11px] tw-text-slate-700 tw-font-medium tw-truncate">{a.file_name}</span>
            {a.byte_size ? (
              <span className="tw-text-[10px] tw-text-slate-400 tw-shrink-0">{fmtBytes(a.byte_size)}</span>
            ) : null}
          </a>
        );
      })}
    </div>
  );
};

ActivityAttachments.propTypes = {
  attachments: PropTypes.array,
};

export default ActivityAttachments;
